import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const activitySlice = createSlice({
  name: "activity",
  initialState,
  reducers: {
    setActivity(state, action) {
      state.activity = action.payload;
    }
  }
});

const { actions, reducer } = activitySlice;

export const { setActivity } = actions;

export const setActivityAction = data => async dispatch => {
  dispatch(setActivity(data));
};

export default reducer;
